/* eslint-disable */
import { getCountryISO3 } from './countries'
import ls from './localStorage'

export function formatName(name) {
  return name?.replace(/\s/g, '_')?.replace('-', '*')?.replace(/\./g, '-')?.toLowerCase()
}

export function initialsLetter(name) {
  let initial = ''
  const word = formatName(name)

  if (word.includes('_')) {
    const splitWord = word.split('_')

    initial = `${splitWord[0].charAt(0)}${splitWord[1].charAt(0)}`
  } else {
    initial = word.charAt(0)
  }

  return initial.toUpperCase()
}

export function withCheckDigit(gtin) {
  let data,
    sum = 0,
    checkdigit
  gtin = Number(gtin)
  if (isNaN(gtin)) {
    return new Error('Argument' + gtin + 'is not valid type number')
  }
  data = ('' + gtin).split('').reverse()
  for (let i = 0; i < data.length; i++) {
    let num = parseInt(data[i]) // eslint-disable-line
    if (i % 2) {
      sum += num
    } else {
      sum += num * 3
    }
  }
  checkdigit = Math.ceil(sum / 10) * 10 - sum
  return gtin.toString() + checkdigit.toString()
}

export function mountUrlGoogleShopping(brandName, gtin, getLiteral) {
  if (!gtin) {
    return `https://www.google.com.br/search?tbm=shop&q=${brandName} ${getLiteral('1047')}`
  }
  return `https://www.google.com.br/search?tbm=shop&q=${
    gtin.toString().length === 14
      ? withCheckDigit(parseInt(gtin.toString().substr(1, 12))) // eslint-disable-line
      : gtin.toString().length === 12
      ? withCheckDigit(gtin)
      : gtin
  }`
}

export function getViewportSize() {
  return {
    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  }
}

export function parseParams() {
  let query = window.location.search.substring(1)

  query = query
    ? query.split('&').reduce((acc, curr) => {
        const [a, b] = curr.split('=')
        let search

        try {
          search = decodeURIComponent(b)
        } catch (error) {
          search = b
        }

        acc[a] = a === 'q' ? search : b
        return acc
      }, {})
    : {}

  const config = {
    ...window.appData,
    ...query
  }

  config.anyProduct = Boolean(config.cnpj) ? 'after' : false

  // @todo: deletar
  // config.multiProduct = true
  // config.buyOnline = 'ecommerce'

  config.searchPlaceholder = config.searchPlaceholder
    ? config.searchPlaceholder
    : config.partner
    ? config.partner === 'abracerva'
      ? 'Procure por "IPA", "Weiss" ou "Helles"'
      : 'Procure por "Glúten" ou "Snack"'
    : null

  return config
}

export function formatDistance(str) {
  const val = parseFloat(str) * 1000
  if (val >= 1000) {
    const distanceKm = (val / 1000).toFixed(2)
    return `${distanceKm} Km`
  } else {
    return `${val.toFixed()} m`
  }
}

export function extractSegmentation(segmentation) {
  if (!segmentation) return {}
  const groupSegments = {}
  for (const segment of segmentation) {
    groupSegments[segment.name] = segment
  }

  return groupSegments
}

// https://images.pertinhodemim.com/17897763512068.jpg?width=200&height=100
// https://images.gofind.online/789776353047.jpg
export function replaceImagePath(product, language = '') {
  try {
    const image =
      language === 'es-ES'
        ? product.image_url_es
        : language === 'en-US'
        ? product.image_url_en
        : product.image_url

    return (image || product.imageurl || '')
      .trim()
      .replace('https://images.gofind.online/', 'https://images.pertinhodemim.com/')
      .replace(
        'https://images.pertinhodemim.com/',
        'https://s3-sa-east-1.amazonaws.com/gofind.img.repo/'
      )
  } catch (error) {
    console.log('error replacing path for', product, error.message)
  }
}

function parseResponse(res) {
  try {
    return JSON.parse(res)
  } catch (e) {
    return res
  }
}

export function mountUrl(url, params = {}) {
  let str = url

  if (Object.keys(params).length) {
    str += `${str.includes('?') ? '&' : '?'}`
    str += Object.entries(params)
      .filter(([key, value]) => value)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')
  }

  return str
}

function decodeParamWithPercentage(param) {
  let newValue = param.toString().replace(/%(?!\w\w)/g, '~~pct~~') // ~~pct~~ <-made up replacement

  newValue = decodeURIComponent(newValue)
  newValue = newValue.toString().replace(/~~pct~~/g, '%')

  return newValue
}

export function getLocaleParam(search) {
  const queryParams = new URLSearchParams(search)

  if (!queryParams.has('locale')) return null

  const locale = queryParams.get('locale')
  const [_, country] = locale.split('-')

  const countryISO3 = getCountryISO3(country)

  return { locale, countryISO3 }
}

export function getUrlParams(search) {
  return search
    .slice(search.indexOf('?') + 1)
    .split('&')
    .filter(Boolean)
    .reduce((params, hash) => {
      let [key, val] = hash.split('=')
      let search

      try {
        search = decodeParamWithPercentage(val)
      } catch (error) {
        search = val
      }

      return Object.assign(params, { [key]: search })
    }, {})
}

export function request(
  url,
  { body, params = {}, method = 'GET', contentType = 'application/json' } = {}
) {
  // Return a new promise.
  return new Promise(function (resolve, reject) {
    // Do the usual XHR stuff
    const req = new XMLHttpRequest()
    req.open(method, mountUrl(url, params), true)

    if (contentType) req.setRequestHeader('Content-type', 'application/json')

    req.onreadystatechange = function () {
      if (req.readyState === XMLHttpRequest.DONE) {
        req.status < 300
          ? resolve(parseResponse(req.response))
          : reject(parseResponse(req.response) || Error(req.statusText))
      }
    }

    req.onerror = function () {
      reject(Error('Network Error'))
    }

    // Make the request
    req.send(body ? JSON.stringify(body) : null)
  })
}

export function getWhatsAppUrl(
  whatsapp,
  storeName,
  productName,
  brandName,
  isEstablishment,
  getLiteral
) {
  return `https://api.whatsapp.com/send?phone=55${whatsapp}&text=${
    isEstablishment
      ? getLiteral('2533', [storeName, brandName])
      : getLiteral('2015', [storeName, productName, brandName])
  }`
}

export function getJSON(url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'json'
    xhr.onload = () => {
      const status = xhr.status

      if (status === 200) {
        resolve(xhr.response)
      } else {
        reject(`${status} - ${xhr.response}`)
      }
    }
    xhr.send()
  })
}

export function formatPhoneNumber(phone) {
  const cleaned = String(phone).replace(/\D/g, '')

  let formated
  switch (cleaned.length) {
    case 14:
      formated = `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 5)}) ${cleaned[5]} ${cleaned.slice(
        6,
        10
      )}-${cleaned.slice(10)}`
      break
    case 13:
      formated =
        cleaned[2] === '0'
          ? `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 5)}) ${cleaned.slice(
              5,
              9
            )}-${cleaned.slice(9)}`
          : `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned[4]} ${cleaned.slice(
              5,
              9
            )}-${cleaned.slice(9)}`
      break
    case 12:
      formated = `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(
        4,
        8
      )}-${cleaned.slice(8)}`
      break
    case 11:
      formated = cleaned.startsWith('0')
        ? `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 7)}-${cleaned.slice(7)}`
        : `(${cleaned.slice(0, 2)}) ${cleaned[2]} ${cleaned.slice(3, 7)}-${cleaned.slice(7)}`
      break
    case 10:
      formated = `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`
      break
    case 9:
      formated = `${cleaned[0]} ${cleaned.slice(1, 5)}-${cleaned.slice(5)}`
      break
    case 8:
      formated = `${cleaned.slice(0, 4)}-${cleaned.slice(4)}`
      break
    default:
      formated = cleaned
  }

  return formated?.trim()
}

// format phone number to send to heineken whatsapp api
export function formatPhoneNumberHeinekenApi(phone) {
  const cleaned = String(phone).replace(/\D/g, '')

  let formated
  switch (cleaned.length) {
    case 11:
      formated = `${cleaned.slice(0, 2)}-${cleaned.slice(2, 7)}-${cleaned.slice(7)}`
      break
    case 10:
      formated = `${cleaned.slice(0, 2)}-${cleaned.slice(2, 6)}-${cleaned.slice(6)}`
      break
    case 9:
      formated = `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`
      break
    case 8:
      formated = `${cleaned.slice(0, 4)}-${cleaned.slice(4)}`
      break
    default:
      formated = cleaned
  }

  return formated
}

export function formatDate(date) {
  const cleaned = String(date).replace(/\D/g, '')

  switch (cleaned.length) {
    case 3:
    case 4:
      return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`
    case 5:
    case 6:
    case 7:
    case 8:
      return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4)}`

    default:
      return date
  }
}

export function getDomain() {
  var domain = window.location.hostname
  if (domain.indexOf('.') > 0) return domain.substring(domain.indexOf('.') + 1)
  return domain
}

export function getElasticFieldNameByLanguage(language, field) {
  switch (language) {
    case 'en-US':
      return `${field}_en`
    case 'es-ES':
      return `${field}_es`
    default:
      return field
  }
}

export function getDynamoFieldNameByLanguage(language, field) {
  switch (language) {
    case 'en-US':
      return `${field}En`
    case 'es-ES':
      return `${field}Es`
    default:
      return field
  }
}

export function getGoogleAttributeNameByLanguage(language, field) {
  switch (language) {
    case 'en-US':
      return `${field}EN`
    case 'es-ES':
      return `${field}ES`
    default:
      return field
  }
}

export function parseAddress(user) {
  const country = user?.country?.length === 2 ? user.country : user?.countryCode || user?.country

  let district = ''
  if (user.district) {
    district = user.district
  } else {
    district = ['BRA', 'BR'].includes(country) ? 'Centro' : user.city
  }

  return {
    ...user,
    country,
    zipCode: user?.zipCode || user?.postalCode,
    state: user?.state?.length === 2 ? user.state : user?.stateCode || user?.state,
    district
  }
}

export function parseStatsToProducts(stats) {
  return Object.values(stats).length
    ? Object.values(stats).map(({ gtin, name }) => ({ gtin, productName: name }))
    : [{ gtin: 'all', productName: 'Qualquer produto' }]
}

export function filterEcommerce(stores, position) {
  const user = position?.user
  const state =
    user.hasOwnProperty('state') && user.state.length === 2 ? user.state : user.stateCode

  return stores?.filter((store) => {
    if (isStateEmptyInSettings(store)) return true

    if (foundUserCityInSettings(store, state, user)) return true

    if (foundAnotherCityInStateInSettings(store, state)) return false

    const mustShowForState = store.visiblesStates.includes(state)

    if (user && mustShowForState) return true

    return false
  })
}

function foundUserCityInSettings(store, state, user) {
  if (!store?.visiblesCities || !store?.visiblesCities?.length) return false

  return store?.visiblesCities?.some((city) => {
    if (!city?.name || !city.uf || !user?.city || !state) return false
    return city.name.toLowerCase().trim() === user.city.toLowerCase().trim() && city.uf === state
  })
}

function foundAnotherCityInStateInSettings(store, state) {
  return store?.visiblesCities && store.visiblesCities.some((city) => city.uf === state)
}

function isStateEmptyInSettings(store) {
  return !store.hasOwnProperty('visiblesStates') || !store.visiblesStates.length
}

export function filterStoreBySegments(stores, selectedSegments) {
  const filteredStores =
    selectedSegments?.length && stores?.length
      ? stores.filter((store) => selectedSegments.includes(store.segmentation))
      : stores

  return filteredStores
}

export function setLocalStorageWithExpiry(key, value, ttlMs) {
  const expiry = Date.now() + ttlMs
  localStorage.setItem(key, JSON.stringify({ value, expiry }))
}

export function getLocalStorageWithExpiry(key) {
  const item = localStorage.getItem(key)

  if (!item) return null

  try {
    const { value, expiry } = JSON.parse(item)

    if (Date.now() > expiry) {
      localStorage.removeItem(key)
      return null
    }

    return value
  } catch {
    localStorage.removeItem(key)
    return null
  }
}
